export const accountType = {
  USER: 1,
  CANDIDATE: 2,
};
